import { render } from "./FrissLogo.vue?vue&type=template&id=45a1f745&ts=true"
import script from "./FrissLogo.vue?vue&type=script&lang=ts"
export * from "./FrissLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__